import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Tutorials = () => {
  const show = true;
  if (show) {
  return (
    <React.Fragment>
      <SEO title="Tutorials | DMBD 2025" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Tutorials"
        content="The Conference"
        contentTwo="Tutorials"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        {/* <h4>To be released.</h4> */}
        <div className="entry-content">

        <h2 id="tutorial1">Trustworthiness in Data Science: Fairness, Privacy and Explainability.</h2>
        <br></br>
        <p className="home-p text-justify">
        <h4>Abstract</h4>

          Artificial Intelligence (AI) systems are being increasingly deployed in high-stakes domains, 
          such as healthcare, finance, and robotics. These systems rely on data science methods (e.g., 
          data collection, cleaning, analysis, modeling, and evaluation) for decision-making. As a 
          result, ensuring trustworthy data science has become a fundamental requirement. This 
          tutorial will provide participants with a comprehensive understanding of what it means for 
          AI to be trustworthy, specifically focusing on fairness, privacy, and transparency in data and 
          models. Case studies will be presented based on state-of-the-art and an ongoing EU project 
          COMFORT from healthcare domain.

          <br></br>
          <br></br>
        <h4>Contents</h4>
        <ul>

        </ul>
        <li><strong>Part 1:</strong> Foundations of AI Trustworthiness (Background and definition, Dimensions including
            fairness, accountability, transparency, safety, privacy, robustness, Ethical frameworks and 
            principles, e.g., European Commission)</li>
        <li><strong>Part 2:</strong> Fairness and Bias Auditing (Categories of bias, Bias diagnosis and mitigation, Case 
            studies of AI fairness, and toolkits)</li>
        <li><strong>Part 3:</strong> Privacy Preservation (Categories of privacy leakage, Case studies of privacy leakage, 
            DiQerential privacy, and Impact assessment)</li>
        <li><strong>Part 4:</strong> Explainability (XAI, Impact assessment, Causal explanations on fairness and privacy, 
            Counterfactual analysis)</li>
        <li><strong>Part 5:</strong> Policy and Future Directions (Global policy landscape such as EU AI Act, Future 
            research directions and open challenges)</li>
          <br></br>
        <h4>Speakers</h4>
          <br></br>
          <p text-align="center">
              <img src="images/avatar/lilijiang.png" alt="Lili Jiang" width={159} />
            </p>
            <p text-align="center">
              <strong>
                <div id="name">Prof. Lili Jiang</div>
                Department of Computing Science, Umeå University, Sweden.
              </strong>
            </p>

            <p>Lili Jiang, Associate professor, Department of Computing Science, Umeå 
              University, Sweden. Doctoral degree in computer science. Expertise in data science and AI 
              trustworthiness (privacy, fairness). Former research scientist at NEC Europe Ltd., post-doc 
              researcher at the Max Planck Institute for Informatics in Saarbrücken, Germany
              <br></br>
              https://www.umu.se/en/staff/lili-jiang/
            </p>
            <br></br>

          </p>
          <br></br>
          <hr></hr>


          <h3>DMBD Call for Tutorial Proposals</h3>
          <br></br>
          <p align="justify">
            DMBD 2025 will include tutorial sessions. Their
            aim is to provide a fast introduction to some topics of interest to
            the data mining and big data.{" "}
          </p>
          <p align="justify">
            Prospective organizers of tutorial sessions should submit proposals
            indicating:
          </p>
          <p align="left">
            * Title of the tutorial.
            <br />
            * Rationale of the need for the tutorial at DMBD.
            <br />
            * Short biography and recent photo of the organizers.
            <br />
          </p>
          <p align="justify">
            Proposals are due on or before 	September 15th, 2025 and should be sent via e-mail (in either pdf or plain ASCII text form) to DMBD 2025 secretariat at{" "}
            <a href="mailto: dmbd2025@iasei.org">dmbd2025@iasei.org</a>
          </p>
          <p align="justify">
            Notification of acceptance will be sent to the organizers no later
            than September 20th, 2025.
          </p>
          <p>&nbsp;</p>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
  }
  else {
    return (
      <React.Fragment>
      <SEO title="Tutorials | DMBD 2025" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Tutorials"
        content="The Conference"
        contentTwo="Tutorials"
        linkage="/"

      />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <div>
            <h4>To be released.</h4>
          </div>
        </EmptyTwo>
        {/* <AboutFive />
              <TestimonialContainer classOption="bg-primary-blue" />
              <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    )
  }
};

export default Tutorials;
